import { render, staticRenderFns } from "./EmptyNotificationsSidebar.vue?vue&type=template&id=24a31265&"
import script from "./EmptyNotificationsSidebar.vue?vue&type=script&lang=ts&"
export * from "./EmptyNotificationsSidebar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports